var map = {
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017266095.webp": 3050,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017268486.webp": 9724,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017274521.webp": 51339,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017276377.webp": 86828,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017279109.webp": 47084,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017281324.webp": 12258,
	"./1 SEPTEMBER 2025 PRISM COLLEGE/FB_IMG_1788017283597.webp": 83016,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0004.webp": 27241,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0005.webp": 57518,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0006.webp": 89967,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0007.webp": 32876,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0008.webp": 14085,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0009.webp": 92986,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG-20260810-WA0012.webp": 97922,
	"./10 AUGUST  2026 SRI VISWA SCHOOLS/IMG20260810160609.webp": 50631,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015261922.webp": 41111,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015264937.webp": 63328,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015267092.webp": 74053,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015269236.webp": 42495,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015272687.webp": 21051,
	"./10 NOVEMBER 2025 ALWARDAS COLLEGE/FB_IMG_1788015277165.webp": 97723,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015564136.webp": 38107,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015567125.webp": 80976,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015569307.webp": 42096,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015572049.webp": 99311,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015574245.webp": 65811,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015576694.webp": 3723,
	"./10 OCTOBER  2025 GOPALAPATNAM SCHOOL/FB_IMG_1788015578946.webp": 84759,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017024703.webp": 97509,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017027818.webp": 91519,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017030451.webp": 49964,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017033139.webp": 83690,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017035661.webp": 27584,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017039422.webp": 68091,
	"./10 SEPTEMBER 2025 SANKETHIKA ENGG COLLEGE/FB_IMG_1788017047476.webp": 46457,
	"./11 May 2025 Live session/IMG-20260919-WA0011.webp": 45806,
	"./12 AUGUST 2026 VIGILENCE COMMITY MEETING/IMG-20260812-WA0005.webp": 74182,
	"./12 AUGUST 2026 VIGILENCE COMMITY MEETING/IMG-20260812-WA0006.webp": 22087,
	"./12 AUGUST 2026 VIGILENCE COMMITY MEETING/IMG20260812171448.webp": 36092,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0010.webp": 36686,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0012.webp": 95692,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0015.webp": 16765,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0026.webp": 39863,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0029.webp": 9714,
	"./12 FEB 2026 POSTER LAUNCHING WITH CP/IMG-20260212-WA0039.webp": 22755,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260813-WA0010.webp": 56472,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260813-WA0014.webp": 14676,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0001.webp": 9965,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0003.webp": 62051,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0006.webp": 51036,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0008.webp": 71466,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0009.webp": 33333,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG-20260814-WA0010.webp": 12407,
	"./13 AUGUST 2026 DALTON COLLEGE/IMG20260813162608.webp": 20420,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG-20260613-WA0032.webp": 42487,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG_20260924_225119.webp": 93663,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG_20260924_225438.webp": 5697,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG_20260924_225537.webp": 28211,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG_20260924_225609.webp": 83435,
	"./13 JUNE 2026 SIGNATURE CAMPAIGN NELLORE/IMG_20260924_225719.webp": 26057,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795189558.webp": 28490,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795192504.webp": 35915,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795195494.webp": 74962,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795202417.webp": 36508,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795213003.webp": 73215,
	"./13 July 2025 Review meeting CRC with mantris hotel, Vip road/FB_IMG_1789795230066.webp": 99651,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0001.webp": 37166,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0002.webp": 30159,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0003.webp": 55276,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0005.webp": 91154,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0034.webp": 39102,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260313-WA0037.webp": 36255,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/IMG-20260314-WA0004.webp": 89794,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/Screenshot_2026-03-14-13-48-45-79_6012fa4d4ddec268fc5c7112cbb265e7.webp": 5040,
	"./13 MARCH 2025 PRESS MEET AT DASPALLA/Screenshot_2026-03-14-13-48-48-93_6012fa4d4ddec268fc5c7112cbb265e7.webp": 32579,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808738418.webp": 64605,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808741069.webp": 48389,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808746130.webp": 85311,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808748630.webp": 84076,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808753174.webp": 67533,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808761272.webp": 24277,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808764396.webp": 84929,
	"./13 Mrach 2025 press meet at daspalla for consumer day/FB_IMG_1789808767684.webp": 71246,
	"./13 Mrach 2025 press meet at daspalla for consumer day/IMG-20260919-WA0029.webp": 31053,
	"./13 Mrach 2025 press meet at daspalla for consumer day/Screenshot_2026-09-19-14-35-12-72_a23b203fd3aafc6dcb84e438dda678b6.webp": 19962,
	"./14 June 2025 Awareness meeting organized by Jito ladies and jito vizag 3rd flr tanishq jewllery vizag/IMG-20260919-WA0006.webp": 13783,
	"./14 June 2025 Awareness meeting organized by Jito ladies and jito vizag 3rd flr tanishq jewllery vizag/IMG-20260919-WA0007.webp": 6215,
	"./14 June 2025 Awareness meeting organized by Jito ladies and jito vizag 3rd flr tanishq jewllery vizag/IMG-20260919-WA0008.webp": 73314,
	"./14 June 2025 Awareness meeting organized by Jito ladies and jito vizag 3rd flr tanishq jewllery vizag/IMG-20260919-WA0009.webp": 28877,
	"./14 June 2025 Awareness meeting organized by Jito ladies and jito vizag 3rd flr tanishq jewllery vizag/IMG-20260919-WA0010.webp": 96959,
	"./15 AUGUST 2025 FLAG HOISTING/FB_IMG_1788020151235.webp": 39147,
	"./15 AUGUST 2025 FLAG HOISTING/FB_IMG_1788020154050.webp": 50865,
	"./15 AUGUST 2025 FLAG HOISTING/FB_IMG_1788020156474.webp": 22361,
	"./15 AUGUST 2025 FLAG HOISTING/FB_IMG_1788020158930.webp": 55716,
	"./15 AUGUST 2025 FLAG HOISTING/FB_IMG_1788020163149.webp": 2214,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0008.webp": 59540,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0009.webp": 1399,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0018.webp": 77025,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0019.webp": 62182,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0020.webp": 21394,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0022.webp": 3280,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0024.webp": 83758,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0026.webp": 85516,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0050.webp": 33909,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0051(1).webp": 94168,
	"./15 AUGUST 2026  AWARD PICS/IMG-20260815-WA0051.webp": 29642,
	"./15 AUGUST 2026 FLAG HOISTING/IMG-20260815-WA0000.webp": 3381,
	"./15 AUGUST 2026 FLAG HOISTING/IMG-20260815-WA0001.webp": 70026,
	"./15 AUGUST 2026 FLAG HOISTING/IMG-20260815-WA0002.webp": 86315,
	"./15 AUGUST 2026 FLAG HOISTING/IMG-20260815-WA0005.webp": 23942,
	"./15 AUGUST 2026 FLAG HOISTING/IMG-20260815-WA0007.webp": 59172,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260615-WA0040.webp": 2667,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260615-WA0041.webp": 94728,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260615-WA0042.webp": 34133,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0016.webp": 10994,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0018.webp": 56436,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0020.webp": 84551,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0022.webp": 35137,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0024.webp": 78059,
	"./15 JUNE 2026 VIZIANAGARAM/IMG-20260820-WA0030.webp": 97298,
	"./15 JUNE 2026 VIZIANAGARAM/IMG_20260820_205012.webp": 33257,
	"./15 JUNE 2026 VIZIANAGARAM/IMG_20260924_220819.webp": 80982,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5551.webp": 75831,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5607.webp": 78161,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5616.webp": 83303,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5656.webp": 21731,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5695.webp": 13054,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5734.webp": 83684,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5741.webp": 59636,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5803.webp": 52479,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5812 (1).webp": 90867,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5823.webp": 79909,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5826.webp": 78934,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5955.webp": 62079,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5961.webp": 1912,
	"./15 MARCH 2026 WORLD CONSUMER DAY/IMG_5965.webp": 60116,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800729032.webp": 32846,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800732618.webp": 29532,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800734021.webp": 81676,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800743602.webp": 10323,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800746592.webp": 68722,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800763147.webp": 81339,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800774233.webp": 82781,
	"./15 March 2025 World consumer day celebrations at Zilla parishad vizag/FB_IMG_1789800776577.webp": 8390,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015495934.webp": 61695,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015498813.webp": 38742,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015500865.webp": 46193,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015503368.webp": 28368,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015505812.webp": 10462,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015508193.webp": 53983,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015521496.webp": 2448,
	"./15 OCTOBER 2025  NELLORE PRESSMEET/FB_IMG_1788015534849.webp": 75162,
	"./16 DECEMBER 2025 BVK SCHOOL/FB_IMG_1788014035460.webp": 75422,
	"./16 DECEMBER 2025 BVK SCHOOL/FB_IMG_1788014037406.webp": 9060,
	"./16 DECEMBER 2025 BVK SCHOOL/FB_IMG_1788014040333.webp": 9615,
	"./16 DECEMBER 2025 BVK SCHOOL/FB_IMG_1788014043326.webp": 96842,
	"./16 DECEMBER 2025 BVK SCHOOL/FB_IMG_1788014045809.webp": 26894,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015281286.webp": 83006,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015284187.webp": 93177,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015285911.webp": 41335,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015288328.webp": 35224,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015291364.webp": 87706,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015293767.webp": 79745,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015302290.webp": 25907,
	"./16 OCTOBER 2025 BVK COLLEGE/FB_IMG_1788015308296.webp": 58247,
	"./17 SEPTEMBER 2025 MEDICAL CAMP DONDAPARTHY/FB_IMG_1788016921751.webp": 20083,
	"./17 SEPTEMBER 2025 MEDICAL CAMP DONDAPARTHY/FB_IMG_1788016925277.webp": 62440,
	"./17 SEPTEMBER 2025 MEDICAL CAMP DONDAPARTHY/FB_IMG_1788016927941.webp": 7262,
	"./17 SEPTEMBER 2025 MEDICAL CAMP DONDAPARTHY/FB_IMG_1788016931482.webp": 33117,
	"./17 SEPTEMBER 2025 MEDICAL CAMP DONDAPARTHY/FB_IMG_1788016941912.webp": 59882,
	"./17 September 2026 prress meet/IMG-20260917-WA0004.webp": 92679,
	"./17 September 2026 prress meet/IMG-20260917-WA0012.webp": 90708,
	"./17 September 2026 prress meet/IMG-20260917-WA0013.webp": 30071,
	"./17 September 2026 prress meet/IMG-20260917-WA0014.webp": 31002,
	"./17 September 2026 prress meet/IMG-20260918-WA0009.webp": 2911,
	"./17 September 2026 prress meet/IMG-20260918-WA0013.webp": 23380,
	"./17 September 2026 prress meet/IMG-20260918-WA0016.webp": 30011,
	"./17 September 2026 prress meet/IMG-20260918-WA0023.webp": 48395,
	"./17 September 2026 prress meet/IMG-20260919-WA0000.webp": 83025,
	"./17 September 2026 prress meet/IMG-20260919-WA0001.webp": 18294,
	"./18 DECEMBER 2025 VT HIGH SCHOOL/FB_IMG_1788014019636.webp": 82800,
	"./18 DECEMBER 2025 VT HIGH SCHOOL/FB_IMG_1788014021977.webp": 58187,
	"./18 DECEMBER 2025 VT HIGH SCHOOL/FB_IMG_1788014024259.webp": 9531,
	"./18 DECEMBER 2025 VT HIGH SCHOOL/FB_IMG_1788014026278.webp": 71288,
	"./18 DECEMBER 2025 VT HIGH SCHOOL/FB_IMG_1788014029303.webp": 35750,
	"./18 JULY 2025 INTELLI SCHOOL/55400357887_1a423266e9_w.webp": 90981,
	"./18 JULY 2025 INTELLI SCHOOL/55400358567_5b82afb43e_w.webp": 61608,
	"./18 JULY 2025 INTELLI SCHOOL/55400358962_78a8dfdd6d_w.webp": 63603,
	"./18 JULY 2025 INTELLI SCHOOL/55400359082_0f382ab3d2_w.webp": 27620,
	"./18 JULY 2025 INTELLI SCHOOL/55401303856_7cc1bb4f69_w.webp": 51769,
	"./18 JULY 2025 INTELLI SCHOOL/55401303866_1605c1548f_w.webp": 97394,
	"./18 JULY 2025 INTELLI SCHOOL/55401303991_91507a0e5e_w.webp": 58296,
	"./18 JULY 2025 INTELLI SCHOOL/55401304896_c29e3fbd6f_w.webp": 94985,
	"./18 JULY 2025 INTELLI SCHOOL/55401428773_232a2552fb_w.webp": 60218,
	"./18 JULY 2025 INTELLI SCHOOL/55401429518_c4f491735b_w.webp": 21000,
	"./18 JULY 2025 INTELLI SCHOOL/55401478934_ba54887dd1_w.webp": 92562,
	"./18 JULY 2025 INTELLI SCHOOL/55401694520_65b51baacc_w.webp": 86222,
	"./18 JULY 2025 INTELLI SCHOOL/IMG-20260718-WA0022.webp": 11780,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260819-WA0044.webp": 50236,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0003.webp": 23533,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0004.webp": 64604,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0005.webp": 71199,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0006.webp": 82558,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0007.webp": 23993,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0008.webp": 54472,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0009.webp": 94379,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0010.webp": 20541,
	"./19 AUGUST 2026 AVN COLLEGE/IMG-20260820-WA0011.webp": 95826,
	"./19 April 2025 online session with Dr.Sreenevasa rao for career guidence/IMG-20260919-WA0026.webp": 99764,
	"./19 April 2025 online session with Dr.Sreenevasa rao for career guidence/IMG-20260919-WA0027.webp": 41623,
	"./19 April 2025 online session with Dr.Sreenevasa rao for career guidence/IMG-20260919-WA0028.webp": 79410,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788013990469.webp": 62846,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788013992709.webp": 71235,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788013995277.webp": 10374,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788013997910.webp": 26398,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788014003962.webp": 79224,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788014006592.webp": 93190,
	"./19 DECEMBER 2025 GAYATRI MVP/FB_IMG_1788014010154.webp": 4621,
	"./19 JUNE 2026 SRIKAKULAM/FB_IMG_1787240865108.webp": 84234,
	"./19 JUNE 2026 SRIKAKULAM/FB_IMG_1787240869947.webp": 59319,
	"./19 JUNE 2026 SRIKAKULAM/FB_IMG_1787240874935.webp": 90804,
	"./19 JUNE 2026 SRIKAKULAM/FB_IMG_1790272614940.webp": 12617,
	"./19 JUNE 2026 SRIKAKULAM/FB_IMG_1790272628225.webp": 65944,
	"./2 FEB 2026 POSTER LAUNCH WITH ACTOR SUMAN/IMG-20260202-WA0015.webp": 98071,
	"./2 FEB 2026 POSTER LAUNCH WITH ACTOR SUMAN/IMG-20260202-WA0025.webp": 77740,
	"./2 FEB 2026 POSTER LAUNCH WITH ACTOR SUMAN/IMG-20260202-WA0026.webp": 14761,
	"./2 FEB 2026 POSTER LAUNCH WITH ACTOR SUMAN/IMG-20260202-WA0027.webp": 75662,
	"./2 FEB 2026 POSTER LAUNCH WITH ACTOR SUMAN/IMG-20260202-WA0028.webp": 67355,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0008.webp": 50191,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0011.webp": 13709,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0015.webp": 41017,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0017.webp": 39583,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0022.webp": 90415,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0027.webp": 76368,
	"./2 MAY 2026 MEDCHAL & MALKAJAGIRI PRESSMEET/IMG-20260502-WA0035.webp": 38147,
	"./2 SEPTEMBER 2025 PYDAH WOMEN COLLEGE/FB_IMG_1788017205091.webp": 54651,
	"./2 SEPTEMBER 2025 PYDAH WOMEN COLLEGE/FB_IMG_1788017207804.webp": 6367,
	"./2 SEPTEMBER 2025 PYDAH WOMEN COLLEGE/FB_IMG_1788017210218.webp": 12100,
	"./20 AUGUST 2025 GADIRAJU PALACE AWARENESS/FB_IMG_1788020135353.webp": 61783,
	"./20 AUGUST 2025 GADIRAJU PALACE AWARENESS/FB_IMG_1788020137486.webp": 89834,
	"./20 AUGUST 2025 GADIRAJU PALACE AWARENESS/FB_IMG_1788020140089.webp": 5397,
	"./20 AUGUST 2025 GADIRAJU PALACE AWARENESS/FB_IMG_1788020142340.webp": 6101,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799808633.webp": 61423,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799814325.webp": 30212,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799816300.webp": 76855,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799819600.webp": 51251,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799824326.webp": 168,
	"./20 April 2025 Awareness and Memebership Campaign At Tamilnadu/FB_IMG_1789799834007.webp": 86511,
	"./20 DECEMBER 2025 SRI VIDYA EDUCATIOONAL/FB_IMG_1788013962347.webp": 70057,
	"./20 DECEMBER 2025 SRI VIDYA EDUCATIOONAL/FB_IMG_1788013965299.webp": 47750,
	"./20 DECEMBER 2025 SRI VIDYA EDUCATIOONAL/FB_IMG_1788013972521.webp": 90468,
	"./20 DECEMBER 2025 SRI VIDYA EDUCATIOONAL/FB_IMG_1788013976873.webp": 46972,
	"./20 DECEMBER 2025 SRI VIDYA EDUCATIOONAL/FB_IMG_1788013981600.webp": 42582,
	"./22 DECEMBER 2025 GAYATRI COLLEGE DWARAKA NAGAR/FB_IMG_1788013942186.webp": 53765,
	"./22 DECEMBER 2025 GAYATRI COLLEGE DWARAKA NAGAR/FB_IMG_1788013946057.webp": 38712,
	"./22 DECEMBER 2025 GAYATRI COLLEGE DWARAKA NAGAR/FB_IMG_1788013948708.webp": 5679,
	"./22 DECEMBER 2025 GAYATRI COLLEGE DWARAKA NAGAR/FB_IMG_1788013951419.webp": 54646,
	"./22 DECEMBER 2025 GAYATRI COLLEGE DWARAKA NAGAR/FB_IMG_1788013956665.webp": 84264,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013565915.webp": 57192,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013578992.webp": 4655,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013585170.webp": 43991,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013587922.webp": 22454,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013594746.webp": 72770,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013597361.webp": 16014,
	"./23 DECEMBER 2025 ANAKAPALLI AWARENESS/FB_IMG_1788013841390.webp": 86470,
	"./24 DECEMBER 2025 National Consumer Day State Award/FB_IMG_1788010304300.webp": 29124,
	"./24 DECEMBER 2025 National Consumer Day State Award/FB_IMG_1788010310065.webp": 73887,
	"./24 DECEMBER 2025 National Consumer Day State Award/FB_IMG_1788010349692.webp": 74305,
	"./24 DECEMBER 2025 National Consumer Day State Award/FB_IMG_1790440645943.webp": 541,
	"./24 DECEMBER 2025 National Consumer Day State Award/FB_IMG_1790440664093.webp": 27944,
	"./24 DECEMBER 2025 Vizag Dist Award/FB_IMG_1788012884943.webp": 3190,
	"./24 DECEMBER 2025 Vizag Dist Award/IMG_20260826_180338.webp": 76516,
	"./24 DECEMBER 2025 Vizag Dist Award/IMG_20260829_194759.webp": 47261,
	"./24 July 2025 Meeting with Rotary club/FB_IMG_1789795040427.webp": 51503,
	"./24 July 2025 Meeting with Rotary club/FB_IMG_1789795044136.webp": 96570,
	"./24 July 2025 Meeting with Rotary club/FB_IMG_1789795050802.webp": 75621,
	"./24 July 2025 Meeting with Rotary club/FB_IMG_1789795058469.webp": 97954,
	"./24 July 2025 Meeting with Rotary club/FB_IMG_1789795065275.webp": 93753,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0001.webp": 24563,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0002.webp": 16914,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0003.webp": 41629,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0006.webp": 62926,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0008.webp": 83512,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260525-WA0034.webp": 90343,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260526-WA0049.webp": 63260,
	"./25 MAY 2026 VIZAG PRESSMEET/IMG-20260526-WA0060.webp": 31513,
	"./25 MAY 2026 VIZAG PRESSMEET/InShot_20260526_115359911.webp": 66990,
	"./26 April 2025 Candle light march for pahalgam attack/26 April 2025 Onlne session Dr.Ashok ji about blood donors/FB_IMG_1789799336543.webp": 20271,
	"./26 April 2025 Candle light march for pahalgam attack/26 April 2025 Onlne session Dr.Ashok ji about blood donors/FB_IMG_1789799343249.webp": 87604,
	"./26 April 2025 Candle light march for pahalgam attack/26 April 2025 Onlne session Dr.Ashok ji about blood donors/FB_IMG_1789799345978.webp": 22611,
	"./26 April 2025 Candle light march for pahalgam attack/26 April 2025 Onlne session Dr.Ashok ji about blood donors/FB_IMG_1789799349041.webp": 22748,
	"./26 April 2025 Candle light march for pahalgam attack/FB_IMG_1789798017730.webp": 12495,
	"./26 April 2025 Candle light march for pahalgam attack/FB_IMG_1789798022545.webp": 5321,
	"./26 April 2025 Candle light march for pahalgam attack/FB_IMG_1789798025649.webp": 53643,
	"./26 April 2025 Candle light march for pahalgam attack/FB_IMG_1789798029078.webp": 14849,
	"./26 July 2025 Awreness meeting at Sri Vidya Vikas jr.college/FB_IMG_1789797291401.webp": 7753,
	"./26 July 2025 Awreness meeting at Sri Vidya Vikas jr.college/FB_IMG_1789797297426.webp": 37380,
	"./26 July 2025 Awreness meeting at Sri Vidya Vikas jr.college/FB_IMG_1789797304249.webp": 75004,
	"./26 July 2025 Awreness meeting at Sri Vidya Vikas jr.college/FB_IMG_1789797311551.webp": 64514,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800471497.webp": 49058,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800473595.webp": 60329,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800485210.webp": 18844,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800489989.webp": 22899,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800494443.webp": 22432,
	"./26 March 2025 Press meet for parking issue/FB_IMG_1789800496926.webp": 36008,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016803739.webp": 64115,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016806234.webp": 27638,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016808336.webp": 5705,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016812995.webp": 56385,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016816576.webp": 23462,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016823528.webp": 87609,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016827159.webp": 99137,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016833408.webp": 6223,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016840558.webp": 87083,
	"./27 SEPTEMBER  2025 YOUTHWING POSTER LAUNCH/FB_IMG_1788016847761.webp": 19238,
	"./28 AUGUST 2025 SRIKAKULAM/FB_IMG_1788020063187.webp": 22860,
	"./28 AUGUST 2025 SRIKAKULAM/FB_IMG_1788020073187.webp": 10071,
	"./28 AUGUST 2025 SRIKAKULAM/FB_IMG_1788020080934.webp": 75879,
	"./28 AUGUST 2025 SRIKAKULAM/FB_IMG_1788020084053.webp": 8943,
	"./28 AUGUST 2025 SRIKAKULAM/FB_IMG_1788020091307.webp": 62681,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016533452.webp": 98514,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016535568.webp": 58898,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016537122.webp": 59138,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016539741.webp": 52861,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016541505.webp": 30870,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016545046.webp": 61040,
	"./28 SEPTEMBER 2025 MEDICAL CAMP LALITHANAGAR/FB_IMG_1788016546953.webp": 53438,
	"./29 JUNE 2026 VIJAYAWADA/FB_IMG_1787240791828.webp": 2723,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0001.webp": 25195,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0002.webp": 15850,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0003.webp": 77717,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0004.webp": 61636,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0034.webp": 4863,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0035.webp": 60572,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0036.webp": 77433,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0037.webp": 92926,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260629-WA0038.webp": 71115,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260630-WA0022 - Copy.webp": 46878,
	"./29 JUNE 2026 VIJAYAWADA/IMG-20260630-WA0022.webp": 11486,
	"./29 JUNE 2026 VIJAYAWADA/IMG_20260925_193621 - Copy.webp": 3903,
	"./29 JUNE 2026 VIJAYAWADA/IMG_20260925_193621.webp": 39841,
	"./29 March 2026 MOU Between CRC and BNI/FB_IMG_1791374696130.webp": 52019,
	"./29 March 2026 MOU Between CRC and BNI/FB_IMG_1791374701793.webp": 65119,
	"./29 March 2026 MOU Between CRC and BNI/FB_IMG_1791374704416.webp": 59456,
	"./29 March 2026 MOU Between CRC and BNI/IMG_20261007_174016.webp": 88421,
	"./3 AUGUST 2025 MEETING WITH MINISTER/FB_IMG_1788021423947.webp": 42550,
	"./3 AUGUST 2025 MEETING WITH MINISTER/FB_IMG_1788021426661.webp": 79074,
	"./3 AUGUST 2025 MEETING WITH MINISTER/FB_IMG_1788021437471.webp": 88939,
	"./3 JUNE 2026 NELLORE Pressmeet/IMG-20260603-WA0001.webp": 55895,
	"./3 JUNE 2026 NELLORE Pressmeet/IMG-20260603-WA0002.webp": 30422,
	"./3 JUNE 2026 NELLORE Pressmeet/IMG_20260924_215301.webp": 7924,
	"./3 JUNE 2026 NELLORE Pressmeet/IMG_20260924_215335.webp": 27107,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03278.webp": 13007,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03383.webp": 45098,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03398.webp": 60110,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03416.webp": 10881,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03449.webp": 56269,
	"./3 MAY 2026 MEDCHAL Public Program/DSC03535.webp": 45961,
	"./3 MAY 2026 MEDCHAL Public Program/IMG-20260513-WA0003.webp": 60978,
	"./3 MAY 2026 MEDCHAL Public Program/IMG-20260513-WA0004.webp": 99983,
	"./3 MAY 2026 MEDCHAL Public Program/IMG-20260513-WA0012.webp": 29756,
	"./3 MAY 2026 MEDCHAL Public Program/IMG-20260513-WA0015.webp": 88685,
	"./3 MAY 2026 MEDCHAL Public Program/IMG_20260924_175434.webp": 39667,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/0B2A3722.webp": 62212,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/0B2A3745.webp": 62235,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/0B2A3751.webp": 80262,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/0B2A3757.webp": 98120,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/0B2A3847.webp": 93732,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788016921751.webp": 58060,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788017126907.webp": 65797,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788017128568.webp": 30252,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788017132251.webp": 10428,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788017135677.webp": 87043,
	"./3 SEPTEMBER 2025 CRC BOOK LAUNCH/FB_IMG_1788017138919.webp": 72907,
	"./3 September 2026 bok launch and paper launch/033A7454.webp": 49442,
	"./3 September 2026 bok launch and paper launch/033A7497.webp": 75911,
	"./3 September 2026 bok launch and paper launch/033A7535.webp": 15192,
	"./3 September 2026 bok launch and paper launch/033A7538.webp": 87599,
	"./3 September 2026 bok launch and paper launch/033A7539.webp": 12716,
	"./3 September 2026 bok launch and paper launch/033A7540.webp": 68456,
	"./3 September 2026 bok launch and paper launch/033A7541.webp": 2699,
	"./3 September 2026 bok launch and paper launch/033A7544.webp": 75556,
	"./3 September 2026 bok launch and paper launch/033A7545.webp": 39591,
	"./3 September 2026 bok launch and paper launch/033A7548.webp": 28288,
	"./3 September 2026 bok launch and paper launch/033A7563.webp": 67151,
	"./3 September 2026 bok launch and paper launch/033A7584.webp": 66648,
	"./3 September 2026 bok launch and paper launch/033A7602.webp": 62647,
	"./3 September 2026 bok launch and paper launch/033A7603.webp": 20788,
	"./3 September 2026 bok launch and paper launch/033A7606.webp": 5403,
	"./3 September 2026 bok launch and paper launch/IMG_20260915_183048.webp": 70473,
	"./3 September 2026 bok launch and paper launch/image_22d648bd.webp": 40135,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0104.webp": 69192,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0105.webp": 77131,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0137.webp": 1986,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0144.webp": 67564,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0164.webp": 52762,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0175.webp": 30628,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0181.webp": 33871,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0182.webp": 80526,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0184.webp": 36176,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0185.webp": 30259,
	"./30 JUNE 2026 TIRUPATI/IMG-20260630-WA0197.webp": 99808,
	"./30 JUNE 2026 TIRUPATI/IMG-20260701-WA0017.webp": 88442,
	"./30 JUNE 2026 TIRUPATI/IMG-20260702-WA0005.webp": 69522,
	"./30 JUNE 2026 TIRUPATI/IMG-20260702-WA0006.webp": 3795,
	"./30 January 2025 Begining of National momment againist Corrupted Education/FB_IMG_1789801329243.webp": 30583,
	"./30 January 2025 Begining of National momment againist Corrupted Education/FB_IMG_1789801335052.webp": 66688,
	"./30 January 2025 Begining of National momment againist Corrupted Education/FB_IMG_1789801336951.webp": 20637,
	"./30 January 2025 Begining of National momment againist Corrupted Education/FB_IMG_1789801340203.webp": 6596,
	"./30 MAY 2026 HYDERABAD Training Session/DSC07851.webp": 52997,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0083.webp": 47657,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0087.webp": 30333,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0091.webp": 53566,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0095.webp": 65378,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0128.webp": 45945,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260531-WA0133.webp": 53265,
	"./30 MAY 2026 HYDERABAD Training Session/IMG-20260601-WA0131.webp": 76413,
	"./31 MAY 2026 HYD PRESS MEET/FB_IMG_1790263571344.webp": 22863,
	"./31 MAY 2026 HYD PRESS MEET/FB_IMG_1790263586344.webp": 56953,
	"./31 MAY 2026 HYD PRESS MEET/FB_IMG_1790263600989.webp": 7373,
	"./31 MAY 2026 HYD PRESS MEET/FB_IMG_1790264956636.webp": 89141,
	"./31 MAY 2026 HYD PRESS MEET/IMG_20260924_211019.webp": 44760,
	"./31 MAY 2026 HYD PRESS MEET/IMG_20260924_211130.webp": 98458,
	"./5 AUGUST 2025 CIVIL SUPPLY MEETING/FB_IMG_1788020458798.webp": 13120,
	"./5 AUGUST 2025 CIVIL SUPPLY MEETING/FB_IMG_1788020461266.webp": 47658,
	"./5 JAN 2026 MEDIATION  Training cermony/FB_IMG_1787324498755.webp": 64434,
	"./5 JAN 2026 MEDIATION  Training cermony/FB_IMG_1787324501757.webp": 15647,
	"./5 JAN 2026 MEDIATION  Training cermony/FB_IMG_1787324506488.webp": 27293,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016496601.webp": 98444,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016503015.webp": 1864,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016504100.webp": 23498,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016506749.webp": 10901,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016508954.webp": 4667,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016510638.webp": 25291,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016514968.webp": 17727,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016523028.webp": 35042,
	"./5 OCTOBER 2025  MEDICAL CAMP OLD DAIRYFARM/FB_IMG_1788016524351.webp": 35928,
	"./6 JAN 2026 Medical camp/FB_IMG_1790432907358.webp": 4302,
	"./6 JAN 2026 Medical camp/IMG_20260926_193411.webp": 35338,
	"./6 JAN 2026 Medical camp/IMG_20260926_193522.webp": 3739,
	"./6 JAN 2026 Medical camp/IMG_20260926_193745.webp": 84650,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0010.webp": 17929,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0012.webp": 98543,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0014.webp": 605,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0023.webp": 43075,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0024.webp": 23838,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0026.webp": 19452,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0029.webp": 30709,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0030.webp": 86711,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0036.webp": 75493,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0042.webp": 67786,
	"./7 FEB 2026 ANAKAPALLI Medical camp/IMG-20260207-WA0047.webp": 34209,
	"./8 March 2026 Anakapalle Dist office opening/IMG-20260308-WA0068.webp": 45317,
	"./8 March 2026 Anakapalle Dist office opening/IMG-20260308-WA0069.webp": 73818,
	"./8 March 2026 Anakapalle Dist office opening/IMG-20260308-WA0070.webp": 41760,
	"./8 March 2026 Anakapalle Dist office opening/IMG-20260309-WA0001.webp": 20477,
	"./8 March 2026 Anakapalle Dist office opening/IMG-20260309-WA0013.webp": 85542,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1226.webp": 84478,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1229.webp": 62667,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1230.webp": 31357,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1234.webp": 53129,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1235.webp": 83406,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1239.webp": 63066,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1257.webp": 55058,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1258.webp": 63351,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1267.webp": 82533,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1313.webp": 84313,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1314.webp": 89184,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/0B2A1321.webp": 43956,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/IMG-20260114-WA0047.webp": 69746,
	"./9 JAN 2026 MEDIATION CERTIFICATE CERMONY/IMG-20260114-WA0049.webp": 88884,
	"./9 September 2026 Awareness Program at Impulse college at Tirupati/IMG-20260909-WA0018.webp": 93371,
	"./9 September 2026 Awareness Program at Impulse college at Tirupati/IMG-20260909-WA0020.webp": 54648,
	"./9 September 2026 Awareness Program at Impulse college at Tirupati/IMG-20260909-WA0022.webp": 44250
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 37527;